import { Theme } from "@nivo/core"

export const TIMELINE_THEME: Theme = {
	axis: {
		legend: {
			text: {
				fontSize: "12px",
			},
		},
	},
}
